import { createFileRoute, redirect } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@/stores/auth';
import { AuthShell } from '@/components/layout/AuthShell';
import { MfaForm } from '@/features/auth/MfaForm';
import { bootstrapSession } from '@/api/client';

export const Route = createFileRoute('/mfa')({
  beforeLoad: async () => {
    await bootstrapSession();
    const status = useAuthStore.getState().status;
    if (status === 'anonymous') throw redirect({ to: '/login' });
    if (status === 'authed') throw redirect({ to: '/dashboard' });
  },
  component: MfaPage,
});

function MfaPage() {
  const { t } = useTranslation('auth');
  const status = useAuthStore((s) => s.status);
  const reattest = status === 'needs_mfa';
  return (
    <AuthShell
      title={t('mfa.title')}
      subtitle={t('mfa.subtitle')}
    >
      <MfaForm reattest={reattest} />
    </AuthShell>
  );
}
